export default __webpack_public_path__ + "static/media/optika.be067097.png";